import { CloseWhite } from '../../assets/images';

const ViewersHeader = ({ hasBorder, onClose }) => {
    return (
        <div className={`viewers-popup-header ${!hasBorder ? 'no_border' : ''}`}>
            {hasBorder && <h3>Who viewed this story</h3>}

            <button className="close-popup" onClick={onClose}>
                <CloseWhite />
            </button>
        </div>
    );
};

export default ViewersHeader;
